import { Icons } from '@beeline/design-tokens/js/iconfont';
export var ICON_STATE_MAP = {
    success: true,
    error: true,
    disabled: true,
};
export var ORDER_STATE_MAP = {
    active: true,
    visited: true,
    'non-visited': true,
};
export var STEP_ICON_MAP = {
    success: Icons.CheckCircled,
    error: Icons.InfoCircled,
    disabled: Icons.Lock,
};
